import Button from '@material-ui/core/Button';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handleChangeValue, handlePatch } from '../../../../utils/AxiosUtil';
import * as enums from '../../../../utils/EnumMapping';
import * as util from '../../../../utils/Util';
import ErrorAwareAmountField from '../../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import PaymentMethodFormControl from '../../../common/inputfields/PaymentMethodFormControl';

class ModifyTax extends Component {
    fields = ["amount", "selectedPaymentMethod", "paymentDeadline"];

    componentDidMount = () => {
        console.log(this.props)
    }

    state = {
        selectedPaymentMethod: enums.outPaymentMethods.find(p => p.value === this.props.row.paymentMethod),
        amount: this.props.row.amount,
        comment: this.props.row.comment,
        paymentDeadline: new Date(this.props.row.paymentDeadline),
        errors: new Map(),
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/tax';
        const requestObject = {
            "privateId": this.props.row.privateId,
            "taxTypeId": this.props.row.taxTypeId,
            "amount": util.toNumber(this.state.amount),
            "paymentDeadline": util.toDateFormat(this.state.paymentDeadline),
            "paymentMethod": this.state.selectedPaymentMethod.value,
            "comment": this.state.comment,
        };
        handlePatch(path, requestObject, this);
    };

    promiseTaxTypeOptions = async () => {
        const response = await axios.get('/api/taxtypes')
        const renamedCustomers = [];
        response.data.map((taxtype) =>
            renamedCustomers.push({
                label: taxtype.publicId ? taxtype.publicId + '-' + taxtype.name : taxtype.name,
                value: taxtype.privateId,
            }));
        return renamedCustomers;
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            disabled
                            name="selectedTaxType"
                            label="Adónem"
                            errors={this.state.errors}
                            value={this.props.row.taxTypePublicId ? this.props.row.taxTypePublicId + '-' + this.props.row.taxTypeName : this.props.row.taxTypeName} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            name="amount"
                            label="Összeg"
                            value={this.state.amount}
                            errors={this.state.errors}
                            prevValue={this.props.row.amount}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <PaymentMethodFormControl
                            options={enums.outPaymentMethods}
                            value={this.state.selectedPaymentMethod}
                            prevValue={enums.getObjectByValue(enums.paymentMethods, this.props.row.paymentMethod)}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            id="payment-deadline-date"
                            name="paymentDeadline"
                            label="Fizetési határidő"
                            errors={this.state.errors}
                            value={this.state.paymentDeadline}
                            prevValue={this.props.row.paymentDeadline}
                            onChange={v => handleChangeValue(v, "paymentDeadline", this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            value={this.state.comment}
                            prevValue={this.props.row.comment}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Módosít
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(ModifyTax);
